/**
 * TM-1000001726 Phase 3: Frontend-Spiegel des Backend-Enums
 * {@code CrudBindingModeEnum}. Steuert wie die Werte fuer die
 * {@code fieldMappings} aufgeloest werden.
 *
 * <ul>
 *   <li>{@code EXPLICIT}  - alle Felder werden explizit in {@code fieldMappings} gesetzt.</li>
 *   <li>{@code BULK_DTO}  - die Werte werden aus einer einzigen Variablen (DTO/Map)
 *       extrahiert. {@code allowList} und {@code bulkSource} sind dann PFLICHT.</li>
 *   <li>{@code HYBRID}    - zuerst BULK_DTO ueber AllowList anwenden, dann
 *       {@code fieldMappings} ueberschreiben.</li>
 * </ul>
 *
 * @ticket TM-1000001726
 */
export enum CrudBindingModeEnum {
    EXPLICIT,
    BULK_DTO,
    HYBRID
}
